import React, { useState, useEffect } from 'react';
import apiProcessAreas from '../../../api/processAreas';
import MultiSelect from '../../layout/forms/MultiSelect';

const ProcessAreas = ({ selected, setSelected }) => {
    const [processAreas, setProcessAreas] = useState([]);
    const fetchProcessAreas = async (projects) => {
        const result = await apiProcessAreas.post(projects.map(project => project.value));
        var divi = document.createElement("p");
       
        setProcessAreas(result.map(processArea => ({ label:processArea.processAreaName + `\xa0\xa0` + processArea.defaultDescription, value: processArea.processAreaKEY })));
        
        //setProcessAreas(result.map(processArea => ({ label: processArea.processAreaName + processArea.defaultDescription, value: processArea.processAreaKEY })));
 
    }

    useEffect(() => {
        fetchProcessAreas(selected.projects);
    }, [selected.projects]);
    const setSelectedProcessAreas = (processAreas) => setSelected({ ...selected, processAreas });
    return (
        <MultiSelect
            options={processAreas}
            value={selected.processAreas}
            onChange={setSelectedProcessAreas}
            labelledBy="ProcessAreas"
            label="Process area"
        />
        )
    }
export default ProcessAreas